/*
 * Commom utils
 */
import axios from 'axios'
import Raven from 'raven-js'

const utils = function (params) {
  return {
    methods: {
      capitalize: function ([s, ...tring]) {
        return [s.toUpperCase(), ...tring].join('')
      },
      inArray: function (array, comparer) {
        for (var i = 0; i < array.length; i++) {
          if (comparer(array[i])) return true
        }
        return false
      },
      pushIfNotExist: function (array, element, comparer) {
        if (!this.inArray(array, comparer)) {
          array.push(element)
        }
      },
      countryRequest: function (token, url) {
        return axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + token
          },
        })
      },
      getNull: function () {
        return false
      },
      getCountry: function (
        userCO,
        userMX,
        userBR,
        userAR,
        userCL,
        userUY,
        userDEV
      ) {
        if (userCO) return 'CO'
        if (userMX) return 'MX'
        if (userBR) return 'BR'
        if (userAR) return 'AR'
        if (userCL) return 'CL'
        if (userUY) return 'UY'
        if (userDEV) return 'DEV'
      },
      getUserCountry: function (token) {
        this.loading = true

        return axios
          .all([
            this.countryRequest(
              token,
              'https://services.rappi.com/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://services.mxgrability.rappi.com/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://services.rappi.com.br/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://services.rappi.com.ar/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://services.rappi.cl/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://services.rappi.com.uy/ms/application-user/auth'
            ).catch(this.getNull),
            this.countryRequest(
              token,
              'https://microservices.dev.rappi.com/ms/application-user/auth'
            ).catch(this.getNull),
          ])
          .then(
            axios.spread(
              ({
                data: userCO
              }, {
                data: userMX
              }, {
                data: userBR
              }, {
                data: userAR
              }, {
                data: userCL
              }, {
                data: userUY
              }, {
                data: userDEV
              }) => {
                this.loading = false
                const country = this.getCountry(
                  userCO,
                  userMX,
                  userBR,
                  userAR,
                  userCL,
                  userUY,
                  userDEV
                )

                if (!country) {
                  Raven.captureException(
                    new Error('Error getting user country')
                  )
                  throw new Error('Error getting user country')
                }
                return country
              }
            )
          )
          .catch(err => {
            this.loading = false
            this.error = err.toString()
          })
      },
      thenable(object) {
        return new Promise((resolve, reject) => {
          resolve(object)
        })
      },
      validateParams({
        token,
        order_id: orderId,
        country_code: countryCode
      }) {
        if (!token) {
          Raven.captureException(new Error('Missin parameter: user token'))
          throw new Error('missing parameter: user token')
        }
        if (!countryCode) {
          Raven.captureException(new Error('Missin parameter: countryCode'))
          throw new Error('missing parameter: countryCode')
        }

        return true
      },
      shadeColor(color, percent) {
        let R = parseInt(color.substring(1, 3), 16)
        let G = parseInt(color.substring(3, 5), 16)
        let B = parseInt(color.substring(5, 7), 16)

        R = parseInt(R * (100 + percent) / 100)
        G = parseInt(G * (100 + percent) / 100)
        B = parseInt(B * (100 + percent) / 100)

        R = (R < 255) ? R : 255
        G = (G < 255) ? G : 255
        B = (B < 255) ? B : 255

        let RR = ((R.toString(16).length === 1) ? "0" + R.toString(16) : R.toString(16))
        let GG = ((G.toString(16).length === 1) ? "0" + G.toString(16) : G.toString(16))
        let BB = ((B.toString(16).length === 1) ? "0" + B.toString(16) : B.toString(16))

        return "#" + RR + GG + BB
      }
    },
  }
}

export default utils
